import { render, staticRenderFns } from "./SuccessSubmitForm8.vue?vue&type=template&id=73247a9e&scoped=true"
import script from "./SuccessSubmitForm8.vue?vue&type=script&lang=ts"
export * from "./SuccessSubmitForm8.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "73247a9e",
  null
  
)

export default component.exports